import useLocalUsers from './useLocalUsers';

export default useLocalUsers;
